<template>
  <div class="menu-wrapper">
    <router-link v-if="!item.kindOne" :to="item.path">
      <el-menu-item  :href="item.path" :index="item.key" >
        <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
        <span class="navTitle" slot="title">{{ item.title }}</span>
      </el-menu-item>
    </router-link>
    <el-submenu :index="item.key" v-else="item.kindOne">
      <template slot="title">
        <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
        <span class="navTitle">{{ item.title }}</span>
      </template>
      <div v-for="(itemValue,indexValue) in item.kindOne" :key="indexValue">
        <router-link :to="itemValue.path">
          <el-menu-item :index="itemValue.key" ><span class="navTitleTwo">{{ itemValue.title }}</span></el-menu-item>
        </router-link>
      </div>
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.menu-wrapper {
  min-width: 180px;
  .menu-icon {
    margin-right: 10px;
    margin-left: -10px;
    color: #000000;
  }
  .el-menu-item {
    min-width:180px;
  }
  .navTitle {
    display: inline-block;
    min-width:88px;
    text-align:left;
  }
  .navTitleTwo {
    display: inline-block;
    min-width:88px;
    padding-left:30px;
    text-align:left;
  }
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue